import React, { useEffect, useRef, useState } from "react";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import BillingHeaderSection from "./billing-header-section";
import BillingItemsSection from "./billing-items-section";
import BillingFooterSection from "./billing-footer-section";
import CreateProductPanel from "./create-product-panel";
import { useNavigate, useSearchParams } from "react-router-dom";
import { handlea4Print } from "../helper-components/helper-function";
import {
  invoiceCreateAction,
  invoiceDraftCreateAction,
  invoiceEditAction,
  storeDetailsAction,
} from "../../redux/actions/invoices-action";
import { useDispatch } from "react-redux";
import errorToast from "../helper-components/error-toast";
import successToast from "../helper-components/success-toast";
import moment from "moment";
import {
  doctorListAction,
  paymentMethodListAction,
  storeIdAction,
} from "../../redux/actions/general-action";
import BillingPaymentPanel from "./billing-payment-panel";
import LoadingSpinner from "../helper-components/loading-spinner";
import AddressSidebar from "../common-components/address-bar";
import { doctorTableAction } from "../../redux/actions/doctor-action";
import { moduleSettingsGetAllAction } from "../../redux/actions/settings-action";
const CreateEditViewBilling = ({
  invoice = {},
  loading,
  setLoading,
  disabled = false,
  dateDisabled=true,
  page = "create",
  // path={path}
}) => {
  const date = new Date();
  const currentDate = moment(date).format("YYYY-MM-DD");
  const navigate = useNavigate();
  const [is_auto_batch, setIs_auto_batch] = useState(false);
  const [batchModalOpen, setBatchModalOpen] = useState(false);
  const [createProductPanelOpen, setCreateProductPanelOpen] = useState(false);
  const orderData = invoice?.orderData;
  const paymentData = invoice?.paymentData;
  const itemsData = invoice?.itemData;
  const qtyRef = useRef();
  const pack_qty_ref = useRef();
  const [submitLoading, setSubmitLoading] = useState(false);
  const [paymentPanel, setPaymentPanel] = useState(false);
  const [isbarcodeScanning, setIsbarcodeScanning] = useState(false);
  const [selectedItem, setSelectedItem] = useState({
    itemid: "",
    item_name: "",
    index: null,
  });
  const [user_discount, setUser_discount] = useState({
    min: "",
    max: "",
  });
  const [docList, setDocList] = useState([]);
  const [payModesList, setPayModesList] = useState([]);
  const [storeDetails, setStoreDetails] = useState({});
  const [reload, setReload] = useState(false);
  const formValuesRef = useRef(null); // Store latest form values persistently
  const [storeId, setStoreId] = useState("");
  const [searchParams] = useSearchParams();
  const phoneNumber = searchParams.get("phoneNumber") || "";
  const doctor = searchParams.get("doctor") || "";
  const doctorId = searchParams.get("doctorId") || "";

  const id = searchParams.get("id") || "";
  const searchRef = useRef();
  const clickDraftRef = useRef();

  const dispatch = useDispatch();
  const [billCreateInputs, setBillCreateInputs] = useState([]);
  const [billingUomMode, setBillingUomMode] = useState("standard_piece");

  useEffect(() => {
    setLoading(true);
    const is_auto_batch = localStorage.getItem("is_auto_batch");
    setIs_auto_batch(is_auto_batch === "false" ? false : true);

    const data = localStorage.getItem("ModPermission");
    if (data) {
      const parsed = JSON.parse(data);
      const billingData = parsed?.find((obj) => obj?.bill_create_input_fields);
      if (billingData?.bill_create_input_fields) {
        setBillCreateInputs(billingData.bill_create_input_fields);
      }
    }

    const minDiscountPercentage = localStorage.getItem("user_min_dis_per");
    const maxDiscountPercentage = localStorage.getItem("user_max_dis_per");
    setUser_discount({
      min: minDiscountPercentage,
      max: maxDiscountPercentage,
    });
  }, []);

  useEffect(() => {
    dispatch(
      moduleSettingsGetAllAction(
        (res) => {
          if (res?.data) {
            const billingSettings = res.data.find(
              (s) => s.document_name === "Add Billing"
            );
            if (billingSettings) {
              const uomOp = billingSettings.document_setting
                ?.flatMap((section) => section.list)
                ?.find((item) => item.label === "UOM Operation");
              if (uomOp) setBillingUomMode(uomOp.value);
            }
          }
        },
        () => {}
      )
    );
  }, [dispatch]);

  const scheduledDrugValidation = (values) => {
    console.log("111", values);
    let hasError = false;
    let errorMessages = [];

    const ordinalSuffixes = ["st", "nd", "rd"];
    let scheduledList = [];
    values?.data?.forEach((item, index) => {
      if (
        item.item_schedule &&
        item?.item_schedule !== "" &&
        item?.item_schedule !== null &&
        item?.item_schedule !== undefined
      ) {
        scheduledList.push({
          itemNumber: index + 1,
          itemName: item.item_name,
        });
      }
    });
    if (
      scheduledList.length > 0 &&
      (!values?.sot_prescription ||
        values?.sot_prescription === "" ||
        (Array.isArray(values?.sot_prescription) && values?.sot_prescription[0] === ""))
    ) {
      hasError = true;
      errorToast(
        `Prescription is required for ${scheduledList
          .map((item, index) => item?.itemName)
          .join(", ")}`
      );
    }
    return hasError;
  };
  const validationSchema = Yup.object().shape({
    // phone: Yup.object()
    //   .required("Phone number is required")
    //   .test(
    //     "is-ten-digits",
    //     "Please enter valid phone number",
    //     (value) => value && value.label && /^\d{10}$/.test(value.label)
    //   ),

    phone: Yup.object()
      .required("Name/Phone number is required")
      .test("is-valid-phone", "Please enter valid phone number", (value) => {
        if (!value || !value.label) return false;

        const input = value.label.trim();

        // Check if input contains comma (text,mobile format)
        if (input.includes(",")) {
          const parts = input.split(",");
          if (parts.length !== 2) return false;

          const textPart = parts[0].trim();
          const mobilePart = parts[1].trim();

          // Text part should not be empty and mobile part should be 10 digits
          return textPart.length > 0 && /^\d{10}$/.test(mobilePart);
        }

        // Check if input is just a 10-digit mobile number
        if (/^\d{10}$/.test(input)) {
          return true;
        }

        // Check if input is just text (no numbers or only partial numbers)
        if (!/^\d{10}$/.test(input) && input.length > 0) {
          // Allow pure text entries (like customer names)
          return true;
        }

        return false;
      }),

    remarks: Yup.string().max(250, "Remarks must be at most 250 characters"),
    item_free_quantity: Yup.number()
      .min(0, "Free quantity cannot be negative")
      .integer("Must be an integer"),
    sot_custom_invoice_date: Yup.string().required(
      "Custom invoice date is required"
    ),
  });

  const initialValues = {
    // submittedButton: "",
    phone:
      phoneNumber || orderData?.cmr_phone_number
        ? {
          label: phoneNumber || orderData?.cmr_phone_number,
          value: id || orderData?.cmr_phone_number,
        }
        : null,
    cmr_id: orderData?.cmr_id || "",
    cmr_code: orderData?.cmr_code || "",
    cmr_first_name: orderData?.cmr_first_name || "",
    cmr_last_name: orderData?.cmr_last_name || "",
    sot_remarks: orderData?.sot_remarks || storeDetails?.remarks,
    sot_order_status: orderData?.sot_order_status,
    sot_total_gst: orderData?.sot_total_gst || "0.00",
    sot_total_discount: orderData?.sot_total_discount || "0.00",
    sot_sub_total: orderData?.sot_sub_total || "0.00",
    sot_total_amount: orderData?.sot_total_amount || "0.00",
    sot_is_invoice_dis_percentage:
      orderData?.sot_is_invoice_dis_percentage ?? true,
    sot_invoice_discount: orderData?.sot_invoice_discount ?? 0,
    sot_invoice_discount_percentage:
      orderData?.sot_invoice_discount_percentage ?? 0,
    header_dis_per: "",
    header_inv_dis_per: orderData?.sot_is_invoice_dis_percentage
      ? orderData?.sot_invoice_discount_percentage
      : orderData?.sot_invoice_discount,
    sot_prescription: orderData?.sot_prescription || [""],
    sot_id: orderData?.sot_id || "",
    // doctor_name:
    //   doctor || orderData?.doctor_name
    //     ? {
    //         label: doctor || orderData?.doctor_name,
    //         value: doctor || orderData?.doctor_name,
    //       }
    //     : null,
    doctor_name: doctor || orderData?.doctor_name,
    doctor_id: doctorId || orderData?.doctor_id,

    sot_is_store_pick_up: orderData?.sot_is_store_pick_up || false,
    sot_custom_invoice_date: orderData?.sot_custom_invoice_date
      ? moment(orderData?.sot_custom_invoice_date).format("YYYY-MM-DD")
      : null,
    sot_custom_invoice_number: orderData?.sot_custom_invoice_number || "",
    sot_pay_to_address: orderData?.sot_pay_to_address || null, // new
    sot_ship_to_address: orderData?.sot_ship_to_address || null, // new

    // Create product panel form fields - only essential ones
    existing_item_id: "",
    existing_item_code: "",
    existing_molecule_name: "",
    existing_item_generic_name: "",

    tempRowData: {
      item_code: "",
      item_name: "",
      item_uom: "",
      total_sellable_quantity: "",
      quantity: "",
      item_batch_number: "",
      item_exp_date: "",
      item_rack_location: "",
      item_manufacturer_name: "",
      item_schedule: "",
      item_hsn: "",
      item_unit_price: 0,
      item_price_wiithout_tax: 0,
      item_discount_amount: 0.0,
      item_discount_percentage: "",
      item_tax_amount: 0,
      item_gst: 0,
      item_final_price: 0,
      item_margin_percentage: 0,
      item_total_amount: 0,
      item_id: "",
      to_bin_id: "",
      instock: true,
      item_sgst: 0,
      item_cgst: 0,
      item_manufacturer_id: "",
      item_generic_name: "",
      item_free_quantity: "",
      item_refill_days: "",
      item_shortage_qty: "",
      max_pack_qty: 0,
      max_loose_qty: 0,
      item_pack_qty: "",
      item_loose_qty: "",
      // Fields for existing item handling
      existing_item_id: "",
      existing_item_code: "",
      existing_molecule_name: "",
      existing_item_generic_name: "",
      is_existing_item: false,
    },
    data:
      itemsData?.length > 0
        ? itemsData?.map((item, index) => ({
          sl_no: index + 1,
          item_code: item?.item_code,
          item_generic_name: item?.item_generic_name,
          item_name: item?.item_name,
          total_sellable_quantity: item?.total_sellable_quantity ?? "",
          quantity: item?.item_quantity,
          item_pack_qty: item?.item_pack_qty || 0,
          item_loose_qty: item?.item_loose_qty || 0,
          item_free_quantity: item?.item_free_quantity,
          item_uom: item?.item_uom,
          item_batch_number: item?.item_batch_number,
          item_exp_date: item?.item_exp_date
            ? moment(item?.item_exp_date).format("YYYY-MM-DD")
            : "--",
          item_rack_location: item?.item_rack_location,
          item_manufacturer_name: item?.item_manufacturer_name,
          item_schedule: item?.item_schedule,
          item_hsn_code: item?.item_hsn_code,
          item_unit_price: item?.item_unit_price,
          item_price_wiithout_tax: item?.item_price_wiithout_tax ?? 0,
          item_discount_amount: item?.item_discount_amount,
          item_discount_percentage: item?.item_discount_percentage || "",
          item_tax_amount: item?.item_tax_amount ?? 0,
          item_gst: item?.item_gst,
          item_final_price:
            (parseFloat(item?.item_unit_price) *
              parseFloat(item?.item_quantity) -
              parseFloat(item?.item_discount_amount)) /
            parseFloat(item?.item_quantity),
          item_margin_percentage: item?.item_margin_percentage ?? item?.margin_percentage ?? 0,
          item_total_amount: item?.item_total_amount,
          item_selling_price: item?.item_selling_price,
          item_id: item?.item_id,
          to_bin_id: item?.to_bin_id,
          instock: true,
          item_cgst: item?.item_cgst,
          item_sgst: item?.item_sgst,
          itemBatchList: item?.itemBatchList,
          item_pack_price: item?.item_pack_price || 0,
          item_total_tax_percentage: parseFloat(
            item?.item_total_tax_percentage
          ),
          item_manufacturer_id: item?.item_manufacturer_id ?? "",
          minDiscountPercentage: item?.minDiscountPercentage || 0,
          maxDiscountPercentage: item?.maxDiscountPercentage || 0,
          item_uom_id:item?.item_uom_id,
          is_predefined_dis: parseFloat(item?.item_discount_percentage) > 0,
          
        }))
        : [],
    paymentData: paymentData?.map((pay) => ({
      payment_mode_name: pay?.payment_mode_name ?? null,
      payment_amount: pay?.payment_amount ?? null,
      transaction_id: pay?.transaction_id ?? null,
    })),
    otherStores: {},
  };

  useEffect(() => {
    dispatch(doctorListAction(onSuccessDoc, onErrorDoc));
    dispatch(storeIdAction(onSuccessStore, onErrorStore));
    dispatch(paymentMethodListAction(onSuccessPayList, onErrorPayList));
    dispatch(storeDetailsAction(onSuccessStoreDetails, onErrorStoreDetails));
  }, []);

  const onSuccessStore = (data) => {
    setStoreId(data?.data?.store_id);
    setReload(!reload);
  };
  const onErrorStore = () => { };
  const onSuccessStoreDetails = (data) => {
    setStoreDetails(data?.data);
    setLoading(false);
  };
  const onErrorStoreDetails = () => {
    setLoading(false);
  };

  const onSuccessDoc = (data) => {
    setDocList([
      ...data?.data
        ?.filter((item) => item?.dr_name != null)
        .map((item) => {
          const parts = [
            `Dr ${item?.dr_name}`, // name is always there
            item?.dr_hospital || null,
            item?.dr_area || null,
            item?.dr_city || null,
            // item?.dr_state || null,
          ].filter(Boolean); // remove null/undefined/empty

          return {
            label: parts.join("-"),
            value: item?.dr_name,
          };
        }),
      {
        label: "self",
        value: "self",
      },
    ]);
  };
  const onErrorPayList = () => { };
  const onSuccessPayList = (data) => {
    setPayModesList(
      data?.data?.paymentModes.map((item) => {
        return { label: item?.paymentType, value: item?.paymentType };
      })
    );
  };
  const onErrorDoc = () => { };
  const extractPhone = (input) =>
    input?.includes(",") ? input.split(",")[1]?.trim() : input;
  const handleBilling = (values, resetForm) => {
    console.log(values, "fgfdgdfgfdgdfgfdgfdg");

    let actionType = invoiceCreateAction;
    if (values.submittedButton === "draft") {
      actionType = invoiceDraftCreateAction;
    }
    if (page === "edit") {
      actionType = invoiceEditAction;
    }
    const filteredData = values?.data;
    if (
      filteredData.some(
        (item) => parseFloat(item?.item_margin_percentage) < 0
      ) &&
      values.submittedButton !== "draft"
    ) {
      errorToast("Margin is negative, please check");
    } else {
      if (values?.data?.length > 0) {
        setSubmitLoading(true);
        setTimeout(() => {
          dispatch(
            actionType(
              {
                orderData: {
                  is_draft_order:
                    values.submittedButton === "draft" ? true : false,
                  store_id: values?.store_id || storeId || "",
                  cmr_id: values?.cmr_id || "",
                  cmr_phone_number: parseInt(
                    extractPhone(values?.phone?.label)
                  ),
                  sot_total_gst: values?.sot_total_gst || 0,
                  sot_total_discount: values?.sot_total_discount || 0,
                  sot_payment_status:
                    values.submittedButton === "draft" ? "pending" : "paid",
                  sot_transaction_id: "",
                  sot_billing_address: "",
                  sot_remarks: values?.sot_remarks,
                  sot_sub_total: values?.sot_sub_total || 0,
                  sot_total_amount: values?.sot_total_amount || 0,
                  sot_round_off_value: values?.sot_round_off_value || 0,
                  doctor_name: values?.doctor_name?.value,
                  doctor_id: values?.doctor_name?.id,
                  sot_is_invoice_dis_percentage:
                    values?.sot_is_invoice_dis_percentage,
                  sot_invoice_discount: values?.sot_invoice_discount,
                  sot_invoice_discount_percentage:
                    values?.sot_invoice_discount_percentage,
                  sot_prescription: values?.sot_prescription,
                  ...(values?.sot_id ? { sot_id: values?.sot_id } : {}),
                  sot_is_store_pick_up: values?.sot_is_store_pick_up,
                  sot_custom_invoice_date:
                    values?.sot_custom_invoice_date || null,
                  sot_custom_invoice_number:
                    values?.sot_custom_invoice_number || "",
                  sot_pay_to_address: values.sot_pay_to_address,
                  sot_ship_to_address: values.sot_ship_to_address,
                },
                paymentData: values?.paymentData?.map((pay) => ({
                  payment_mode_name: pay?.payment_mode_name,
                  payment_amount: pay?.payment_amount,
                  transaction_id: pay?.transaction_id || null,
                })),
                itemData: values?.data?.map((item, index) => ({
                  item_code: item?.item_code,
                  item_generic_name: item?.item_generic_name ?? "",
                  item_name: item?.item_name,
                  item_quantity: parseInt(item?.quantity),
                  item_pack_qty: item?.item_pack_qty || 0,
                  item_loose_qty: item?.item_loose_qty || 0,
                  item_free_quantity:
                    parseInt(item?.item_free_quantity ?? 0, 10) || 0,
                  item_uom: item?.item_uom,
                  item_batch_number: item?.item_batch_number,
                  item_exp_date: moment(item?.item_exp_date).format(
                    "YYYY-MM-DD"
                  ),
                  item_rack_location: item?.item_rack_location,
                  item_schedule: item?.item_schedule,
                  item_hsn: item?.item_hsn,
                  item_unit_price: parseFloat(item?.item_unit_price),
                  item_price_wiithout_tax: parseFloat(
                    item?.item_price_wiithout_tax
                  ),
                  item_discount_amount: parseFloat(item?.item_discount_amount),
                  item_discount_percentage:
                    parseFloat(item?.item_discount_percentage) || 0,
                  item_tax_amount: parseFloat(item?.item_tax_amount),
                  item_total_amount: parseFloat(
                    parseFloat(item.item_total_amount) 
                    
                  ).toFixed(2),
                  item_selling_price: parseFloat(item?.item_selling_price || 0).toFixed(2),
                  item_id: item?.item_id,
                  item_gst: parseFloat(item?.item_gst),
                  item_sgst: parseFloat(item?.item_sgst||0),
                  item_cgst: parseFloat(item?.item_cgst||0),
                  item_total_tax_percentage: parseFloat(
                    item?.item_total_tax_percentage
                  ),
                  item_pack_price: item?.item_pack_price || 0,
                  item_uom_id:item?.item_uom_id,
                  item_margin_percentage: parseFloat(item?.item_margin_percentage) || 0,
                  // item_manufacturer_id: item?.item_manufacturer_id ?? "",
                  // item_manufacturer_name: item?.item_manufacturer_name ?? "",
                  is_store_added_item: item?.is_store_added_item||false,
                  is_promotional: item?.is_promotional || false,
                  po_id: item?.po_id || null,
                })),
              },
              (data) => {
                setSubmitLoading(false);
                resetForm();
                setPaymentPanel(false);
                if (values.submittedButton === "print") {
                  handlea4Print(
                    data?.data?.orderData?.[0]?.sot_id,
                    "Billing",
                    dispatch
                  );

                  //Needed for unwrap
                  // handlePrint(data?.data, storeDetails);
                }
                successToast(data?.message);
                setLoading(true);
                setTimeout(() => {
                  setLoading(false);
                }, 50);

                if (page === "edit") {
                  navigate("/bills");
                }
                formValuesRef.current = null; // Reset after handling
              },
              onErrorOrder
            )
          );
        }, 500); // Timeout set to 100ms
      }
    }
  };

  const onErrorOrder = (data) => {
    setLoading(false);
    setSubmitLoading(false);
    errorToast(data?.data?.message);
  };

  return (
    <div className="h-full">
      {loading ? (
        <LoadingSpinner />
      ) : (
        <Formik
          enableReinitialize={true}
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={async (values, { resetForm }) => {
            if (values.submittedButton === "proceed") {
              const validate = scheduledDrugValidation(values);
              if (!validate) {
                setPaymentPanel(true); // Trigger payment panel
              }
            } else {
              handleBilling(values, resetForm); // Proceed with billing
            }
          }}
        >
          {({ handleSubmit, setFieldValue, values }) => {
            // Function to recalculate totals after items are added/modified
            const recalculateTotals = () => {
              // The footer section now automatically recalculates totals when data changes
              // This function is kept for backward compatibility but no longer needed
              console.log(
                "Totals will be recalculated automatically by footer section"
              );
            };

            return (
              <Form
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                  }
                }}
                className="h-full w-full"
              >
                <div
                  style={{
                    height: `calc(100% - 8rem)`,
                  }}
                  className="mx-5 flex flex-col h-full "
                >
                  <BillingHeaderSection
                    name="sot"
                    type="billing"
                    storeId={storeId}
                    paymentPanel={paymentPanel}
                    setBatchModalOpen={setBatchModalOpen}
                    batchModalOpen={batchModalOpen}
                    is_auto_batch={is_auto_batch}
                    page={page}
                    disabled={disabled}
                    selectedItem={selectedItem}
                    searchRef={searchRef}
                    qtyRef={qtyRef}
                    dateDisabled={dateDisabled}
                  />
                  <BillingItemsSection
                    billCreateInputs={[...billCreateInputs]}
                    setLoading={setLoading}
                    setBatchModalOpen={setBatchModalOpen}
                    batchModalOpen={batchModalOpen}
                    is_auto_batch={is_auto_batch}
                    pack_qty_ref={pack_qty_ref}
                    disabled={disabled}
                    qtyRef={qtyRef}
                    setSelectedItem={setSelectedItem}
                    selectedItem={selectedItem}
                    searchRef={searchRef}
                    initialValues={initialValues}
                    createProductPanelOpen={createProductPanelOpen}
                    setCreateProductPanelOpen={setCreateProductPanelOpen}
                    isbarcodeScanning={isbarcodeScanning}
                    setIsbarcodeScanning={setIsbarcodeScanning}
                    billingUomMode={billingUomMode}
                    billingStoreId={storeId}
                  />
                </div>
                <BillingFooterSection
                  formValuesRef={formValuesRef}
                  billCreateInputs={billCreateInputs}
                  page={page}
                  disabled={disabled}
                  docList={docList}
                  searchRef={searchRef}
                  clickDraftRef={clickDraftRef}
                  user_discount={user_discount}
                  handleBilling={handleBilling}
                  submitLoading={submitLoading}
                />
                <BillingPaymentPanel
                  disabled={disabled}
                  submitLoading={submitLoading}
                  handleSubmit={handleSubmit}
                  payModesList={payModesList}
                  open={paymentPanel}
                  setOpen={setPaymentPanel}
                />
                <CreateProductPanel
                  isOpen={createProductPanelOpen}
                  setIsOpen={setCreateProductPanelOpen}
                  initialValues={initialValues}
                  setFieldValue={setFieldValue}
                  setSelectedItem={setSelectedItem}
                  selectedItem={selectedItem}
                  qtyRef={qtyRef}
                  disabled={disabled}
                  pack_qty_ref={pack_qty_ref}
                  is_auto_batch={is_auto_batch}
                  setBatchModalOpen={setBatchModalOpen}
                  batchModalOpen={batchModalOpen}
                  setLoading={setLoading}
                  billCreateInputs={billCreateInputs}
                  recalculateTotals={recalculateTotals}
                />
              </Form>
            );
          }}
        </Formik>
      )}
    </div>
  );
};

export default CreateEditViewBilling;
